import axios from '@/axios/axios'

export default {
	namespaced: true,
	actions: {
		requestCorpDetail({ rootState }) {
			return axios
				.get('/api/account/get-profile')
				.then((response) => {
					if (response.status == 200) {
						let data = response.data
						data.activities = JSON.parse(data.activities)
						data.industries1 = JSON.parse(data.industries1)
						data.industries2 = JSON.parse(data.industries2)
						data.phoneNumber = data.phone
						rootState.auth.user = data
						rootState.auth.isChecked = true
						return Promise.resolve(response)
					}

					return Promise.reject(response.message)
				})
				.catch((error) => {
					console.log(error)
					return Promise.reject(error)
				})
		},
		updateCorp({ commit }, payload) {
			return axios
				.post('/api/account/update-profile/corp', payload)
				.then((response) => {
					console.log(response.data)
				})
				.catch((error) => {
					console.log(error.response)
				})
				.finally(() => {
					// 성공, 실패 관련 없이 로그인 정보 삭제
					commit('requestCorpDetail')
					return Promise.resolve()
				})
		},
	},
}
